import React from "react";
import {
    AlertDialog,
    AlertDialogOverlay,
    AlertDialogContent,
    AlertDialogHeader,
    AlertDialogBody,
    AlertDialogFooter,
    Button,
} from "@chakra-ui/react";

type ConfirmBoxProps = {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: () => void;
    title: React.ReactNode;
    description: React.ReactNode;
    cancelRef: React.RefObject<HTMLButtonElement>;
    confirmButtonText?: string;
    cancelButtonText?: string;
    confirmButtonColorScheme?: string;
};

const ConfirmBox: React.FC<ConfirmBoxProps> = ({
    isOpen,
    onClose,
    onConfirm,
    title,
    description,
    cancelRef,
    confirmButtonText = "Confirm",
    cancelButtonText = "Cancel",
    confirmButtonColorScheme = "red",
}) => (
    <AlertDialog
        isOpen={isOpen}
        leastDestructiveRef={cancelRef}
        onClose={onClose}
    >
        <AlertDialogOverlay>
            <AlertDialogContent>
                <AlertDialogHeader fontSize="lg" fontWeight="bold">
                    {title}
                </AlertDialogHeader>
                <AlertDialogBody>
                    {description}
                </AlertDialogBody>
                <AlertDialogFooter>
                    <Button ref={cancelRef} onClick={onClose}>
                        {cancelButtonText}
                    </Button>
                    <Button colorScheme={confirmButtonColorScheme} onClick={onConfirm} ml={3}>
                        {confirmButtonText}
                    </Button>
                </AlertDialogFooter>
            </AlertDialogContent>
        </AlertDialogOverlay>
    </AlertDialog>
);

export default ConfirmBox;